module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      width: "750px",
      alignItems: "center",
      backgroundColor: "#fff"
    }
  }, [_c('div', {
    staticClass: ["dof-simple-rich-text"],
    staticStyle: {
      flexWrap: "wrap",
      flex: "1",
      flexDirection: "row",
      backgroundColor: "#ffffff"
    },
    style: {
      width: _vm.RichTextwidth + 'px'
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: ["textItem"]
    }, [_c('text', {
      class: ['textContent', _vm.hasNumOrEn(item.content) ? '' : 'hasNumOrEn'],
      style: {
        color: item.color,
        fontSize: item.size + 'px'
      }
    }, [_vm._v(_vm._s(item.content))])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-7e3c0e08!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-simple-rich-text/index.vue
// module id = 640
// module chunks = 0 1